import React from "react";
import { CookieKeys } from "@outschool/data-schemas";
import Cookies from "js-cookie";

export default function useCanShowGoogleAuth() {
  const [canShowGoogleAuth, setCanShowGoogleAuth] = React.useState(true);

  React.useEffect(() => {
    const browserName = Cookies.get(CookieKeys.OsBrowserName);
    if (!browserName) {
      setCanShowGoogleAuth(true);
      return;
    }
    setCanShowGoogleAuth(
      ![
        "facebook",
        "instagram",
        "chrome webview",
        "webkit",
        "silk",
        "electron",
        "qqbrowser",
      ].includes(browserName.toLowerCase())
    );
  }, [setCanShowGoogleAuth]);

  return canShowGoogleAuth;
}
